import type { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  firebaseConfig: {
    apiKey: 'AIzaSyABn-ALF200l4B63Wnwha0gRDzHvGmHkPg',
    authDomain: 'moofyvip-firebase.firebaseapp.com',
    projectId: 'moofyvip-firebase',
    storageBucket: 'moofyvip-firebase.firebasestorage.app',
    messagingSenderId: '761256976427',
    appId: '1:761256976427:web:79c70dd152568137c54a6e',
    measurementId: 'G-42KKY19LV1',
  },
  production: false,
  appEnvironmentId: 'sandbox',
  firestoreDatabaseId: 'sandbox',
  screenshotStoragePrefix: 'sandbox',
  scraperRunsApiUrl:
    'https://moofy-scraper-runs-api-sandbox-5ffwk4eevq-uc.a.run.app/scraper-runs',
};
